import { ChainId } from 'sushi'
import type { WalletNamespace } from './types'

export const DEFAULT_CHAIN_ID_BY_NAMESPACE: Record<WalletNamespace, ChainId> = {
  evm: ChainId.ETHEREUM,
}

export const ENABLED_WALLET_NAMESPACES: WalletNamespace[] = ['evm']
export const isWalletNamespaceEnabled = (namespace: WalletNamespace) =>
  ENABLED_WALLET_NAMESPACES.includes(namespace)

export const getNameFromNamespace = (namespace: WalletNamespace) => {
  switch (namespace) {
    case 'evm':
      return 'EVM'
    default:
      return namespace
  }
}
